import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jalAPI } from '../services/api';

const STATUS_CONFIG = {
  en_attente: { label: 'En attente',  color: '#d97706',  bg: 'rgba(217,119,6,0.08)' },
  en_cours:   { label: 'En cours',    color: '#1A55A0',  bg: 'rgba(26,85,160,0.08)' },
  publie:     { label: 'Publiée',     color: '#1A7A4A',  bg: 'rgba(26,122,74,0.08)' },
  erreur:     { label: 'Erreur',      color: '#B03020',  bg: 'rgba(176,48,32,0.08)' },
};

function Badge({ statut }) {
  const s = STATUS_CONFIG[statut] || STATUS_CONFIG.en_attente;
  return (
    <span style={{ fontSize: '11px', fontWeight: 500, padding: '2px 8px', borderRadius: '4px', color: s.color, background: s.bg }}>
      {s.label}
    </span>
  );
}

export default function JAL() {
  const navigate    = useNavigate();
  const [annonces, setAnnonces] = useState([]);
  const [stats, setStats]       = useState(null);
  const [filter, setFilter]     = useState('tous');
  const [loading, setLoading]   = useState(true);

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const [annoncesRes, statsRes] = await Promise.all([
        jalAPI.list(),
        jalAPI.stats(),
      ]);
      setAnnonces(annoncesRes.data || []);
      setStats(statsRes.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filtered = filter === 'tous'
    ? annonces
    : annonces.filter(a => a.statut === filter);

  if (loading) return (
    <div style={{ padding: '3rem', textAlign: 'center', color: 'rgba(26,25,22,0.4)', fontSize: '13px' }}>Chargement…</div>
  );

  const card = { background: '#fff', border: '0.5px solid rgba(0,0,0,0.07)', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' };

  return (
    <div>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1.5rem' }}>
        <div>
          <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '18px', fontWeight: 600, color: '#1A1916' }}>Annonces légales (JAL)</div>
          <div style={{ fontSize: '12px', color: 'rgba(26,25,22,0.4)', marginTop: '2px' }}>Suivi des publications et attestations</div>
        </div>
        <button style={{ background: '#B8860B', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '7px', fontSize: '12px', fontWeight: 500, cursor: 'pointer' }}>
          + Nouvelle annonce
        </button>
      </div>

      {/* KPIs */}
      {stats && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', marginBottom: '1.25rem' }}>
          <div style={{ ...card, padding: '14px 16px' }}>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.07em', color: 'rgba(26,25,22,0.28)', marginBottom: '4px' }}>En attente</div>
            <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '24px', fontWeight: 700, color: stats.en_attente > 0 ? '#d97706' : '#1A1916' }}>{stats.en_attente}</div>
          </div>
          <div style={{ ...card, padding: '14px 16px' }}>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.07em', color: 'rgba(26,25,22,0.28)', marginBottom: '4px' }}>Publiées ce mois</div>
            <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '24px', fontWeight: 700, color: '#1A7A4A' }}>{stats.publiees_mois}</div>
          </div>
          <div style={{ ...card, padding: '14px 16px' }}>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.07em', color: 'rgba(26,25,22,0.28)', marginBottom: '4px' }}>Délai moyen</div>
            <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '24px', fontWeight: 700, color: '#1A1916' }}>{stats.delai_moyen_h}h</div>
          </div>
          <div style={{ ...card, padding: '14px 16px' }}>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.07em', color: 'rgba(26,25,22,0.28)', marginBottom: '4px' }}>Coût moyen HT</div>
            <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '24px', fontWeight: 700, color: '#1A1916' }}>{stats.cout_moyen_ht} €</div>
          </div>
        </div>
      )}

      {/* Infobox agent */}
      <div style={{ background: 'rgba(26,85,160,0.06)', border: '0.5px solid rgba(26,85,160,0.15)', borderRadius: '8px', padding: '10px 14px', fontSize: '12px', color: '#1A55A0', marginBottom: '1.25rem', lineHeight: 1.5 }}>
        ⚙️ L'Agent JAL génère, soumet et récupère l'attestation automatiquement (Les Échos, Infogreffe, Légifrance).{' '}
        <span style={{ fontWeight: 500, cursor: 'pointer', textDecoration: 'underline' }} onClick={() => navigate('/marketplace')}>
          Activer l'agent →
        </span>
      </div>

      {/* Filtres */}
      <div style={{ display: 'flex', gap: '6px', marginBottom: '1rem' }}>
        {[
          { key: 'tous',       label: 'Toutes' },
          { key: 'en_attente', label: 'En attente' },
          { key: 'en_cours',   label: 'En cours' },
          { key: 'publie',     label: 'Publiées' },
          { key: 'erreur',     label: 'Erreurs' },
        ].map(f => (
          <button
            key={f.key}
            onClick={() => setFilter(f.key)}
            style={{
              padding: '4px 12px', borderRadius: '999px', fontSize: '11px', cursor: 'pointer',
              border: '0.5px solid rgba(0,0,0,0.1)',
              background: filter === f.key ? '#1A1916' : 'transparent',
              color:      filter === f.key ? '#fff'     : 'rgba(26,25,22,0.5)',
              fontFamily: 'DM Sans, sans-serif',
            }}
          >
            {f.label}
          </button>
        ))}
      </div>

      {/* Table */}
      <div style={{ ...card, overflow: 'hidden' }}>
        {filtered.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'rgba(26,25,22,0.35)', fontSize: '13px' }}>
            Aucune annonce{filter !== 'tous' ? ' dans ce statut' : ''}.
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '0.5px solid rgba(0,0,0,0.07)' }}>
                {['Dossier', 'Société', 'Journal (JAL)', 'Type annonce', 'Tarif HT', 'Date commande', 'Date publication', 'Statut', 'Attestation'].map(h => (
                  <th key={h} style={{ textAlign: 'left', padding: '10px 14px', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.07em', color: 'rgba(26,25,22,0.28)', fontWeight: 400 }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((a, i) => (
                <tr key={a.id} style={{ borderBottom: i < filtered.length - 1 ? '0.5px solid rgba(0,0,0,0.05)' : 'none' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#F5F3EE'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  <td style={{ padding: '11px 14px', fontSize: '12px', fontWeight: 500, color: '#1A1916', fontFamily: 'monospace' }}>
                    {a.reference}
                  </td>
                  <td style={{ padding: '11px 14px', fontSize: '12px', color: 'rgba(26,25,22,0.7)' }}>
                    {a.societe_nom}
                  </td>
                  <td style={{ padding: '11px 14px', fontSize: '12px', color: 'rgba(26,25,22,0.7)', fontWeight: 500 }}>
                    {a.journal || <span style={{ color: 'rgba(26,25,22,0.3)' }}>—</span>}
                  </td>
                  <td style={{ padding: '11px 14px', fontSize: '12px', color: 'rgba(26,25,22,0.6)' }}>
                    {a.type_annonce}
                  </td>
                  <td style={{ padding: '11px 14px', fontSize: '12px', color: '#1A1916', fontVariantNumeric: 'tabular-nums', fontWeight: 500 }}>
                    {a.tarif_ht != null && a.tarif_ht !== ''
                      ? `${Number(a.tarif_ht).toLocaleString('fr-FR')} €`
                      : <span style={{ color: 'rgba(26,25,22,0.3)' }}>—</span>}
                  </td>
                  <td style={{ padding: '11px 14px', fontSize: '11.5px', color: 'rgba(26,25,22,0.5)', fontVariantNumeric: 'tabular-nums' }}>
                    {a.date_commande
                      ? new Date(a.date_commande).toLocaleDateString('fr-FR')
                      : <span style={{ color: 'rgba(26,25,22,0.3)' }}>—</span>}
                  </td>
                  <td style={{ padding: '11px 14px', fontSize: '11.5px', color: 'rgba(26,25,22,0.5)', fontVariantNumeric: 'tabular-nums' }}>
                    {a.date_publication
                      ? new Date(a.date_publication).toLocaleDateString('fr-FR')
                      : <span style={{ color: 'rgba(26,25,22,0.3)' }}>—</span>}
                  </td>
                  <td style={{ padding: '11px 14px' }}>
                    <Badge statut={a.statut} />
                  </td>
                  <td style={{ padding: '11px 14px' }}>
                    {a.attestation_url ? (
                      <a href={a.attestation_url} target="_blank" rel="noreferrer">
                        <button style={{ background: 'transparent', border: '0.5px solid rgba(0,0,0,0.12)', borderRadius: '5px', padding: '3px 10px', fontSize: '11px', cursor: 'pointer', color: '#1A55A0' }}>
                          ↓ PDF
                        </button>
                      </a>
                    ) : (
                      <span style={{ fontSize: '11px', color: 'rgba(26,25,22,0.25)' }}>—</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Résumé attestations */}
      {stats && stats.publiees_mois > 0 && (
        <div style={{ marginTop: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', background: 'rgba(26,122,74,0.06)', border: '0.5px solid rgba(26,122,74,0.15)', borderRadius: '8px' }}>
          <div style={{ fontSize: '12px', color: '#1A7A4A' }}>
            ✓ {stats.attestations_ok} attestation{stats.attestations_ok > 1 ? 's' : ''} récupérée{stats.attestations_ok > 1 ? 's' : ''} sur {stats.attestations_total} annonces publiées ce mois
          </div>
          {stats.attestations_ok < stats.attestations_total && (
            <span style={{ fontSize: '11px', color: '#d97706' }}>
              {stats.attestations_total - stats.attestations_ok} en attente de récupération
            </span>
          )}
        </div>
      )}
    </div>
  );
}
